(function() {
  angular.module('forgotPassword')
  .factory('resetPasswordFactory', ['$resource', function($resource) {
    return $resource('/resetPassword');
  }])
  .factory('ResetEmail', ['$resource', '$log',
  function($resource, $log) {
    return function(guid) {
      return $resource('users/:userId',{userId:'@userId'},{
        reset: {method: 'PATCH',
          headers: {'x-password-reset-token': guid},
        }
      });
    };
  }]);
})();
